import React from "react";
import "./Footer.css";

export default function Footer() {
    return (
        <footer>
            <p>
                <a
                    href="https://github.com/domsey-web/weather-react"
                >Open-source code
    </a> {" "}
      by <a
                    href="https://domseyi.com"
                >Dominique Seyi
    </a>
            </p>
        </footer>
    )
}